<template>
  <q-dialog
    v-model="shown"
    persistent
    data-test-id="email-dialog"
    :position="$q.screen.lt.sm ? 'bottom' : undefined"
    @hide="reset"
  >
    <q-card
      :style="$q.screen.lt.sm ? 'min-width: 100%' : 'min-width: 50%;'"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section class="row items-center q-mx-xs">
          <div
            class="text-h6 col"
          >
            {{ title }}
          </div>
          <q-space />
          <q-checkbox
            v-if="includeCurrentUserCopy && currentUser"
            v-model="sendCopyToCurrentUser"
            class="col-auto"
            :disable="currentUser.email === emailInput"
            label="Send me a copy"
            left-label
            size="lg"
          >
            <q-tooltip>
              {{ currentUser.email === emailInput ? 'You are already the email recipient' : 'Send a copy of the email to yourself and the recipient' }}
            </q-tooltip>
          </q-checkbox>
        </q-card-section>
        <q-card-section>
          <div class="row items-start q-col-gutter-x-sm">
            <q-input
              ref="emailInput"
              v-model="emailInput"
              :class="includeDeliveryDate && $q.screen.gt.xs ? 'col-8' : 'col-12'"
              label="Recipient Email Address"
              type="email"
              :rules="[val => required.$validator(val) || $t('form.errors.required'),
                       val => email.$validator(val.toLowerCase()) || $t('form.errors.emailNotValid')]"
            />
            <iso-date-input
              v-if="includeDeliveryDate"
              v-model="deliveryDate"
              :class="$q.screen.gt.xs ? 'col-4' : 'col'"
              label="Delivery Date"
              :rules="[val => !!val || $t('form.errors.required')]"
            />
            <q-input
              v-if="includeMessage"
              v-model="messageInput"
              class="col-12"
              maxlength="2000"
              :input-style="{ 'min-height': $q.screen.lt.sm ? '200px' : undefined }"
              label="Custom Message"
              type="textarea"
            />
          </div>
        </q-card-section>

        <q-card-actions class="row q-gutter-lg justify-end q-px-md q-pb-md q-pt-none">
          <q-btn
            class="text-capitalize"
            :class="$q.screen.lt.sm ? 'col' : 'col-auto'"
            size="md"
            padding="sm lg"
            style="min-width: 150px;"
            :label="cancelLabel || $t('actions.cancel')"
            color="responsive-grey-2"
            text-color="responsive"
            @click="cancel"
          />
          <q-btn
            class="col-auto text-capitalize"
            :class="$q.screen.lt.sm ? 'col' : 'col-auto'"
            size="md"
            padding="sm lg"
            style="min-width: 150px;"
            :label="submitLabel || $t('form.actions.submit')"
            color="primary"
            :text-color="$getColor(currentSite, 'primary')"
            @click="submit"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { email, required } from '@vuelidate/validators'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput.vue'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

const now = new Date()

export default {
  name: 'EmailDialog',
  components: {
    IsoDateInput
  },
  mixins: [FormValidationMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: 'Email Required'
    },
    includeMessage: {
      type: Boolean,
      required: false,
      default: true
    },
    includeCurrentUserCopy: {
      type: Boolean,
      required: false,
      default: true
    },
    includeDeliveryDate: {
      type: Boolean,
      required: false,
      default: false
    },
    submitLabel: {
      type: String,
      required: false,
      default: 'Submit'
    },
    cancelLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['submit', 'cancel'],
  data () {
    return {
      emailInput: null,
      messageInput: null,
      sendCopyToCurrentUser: false,
      deliveryDate: now,
      shown: false
    }
  },
  created () {
    _.extend(this, { email, required })
  },
  context: ['currentUser'],
  configuration: ['currentCircuit', 'currentSite'],
  methods: {
    submit () {
      this.validateForm(() => {
        this.$emit('submit', { email: this.emailInput, message: this.messageInput, sendCopyToCurrentUser: this.sendCopyToCurrentUser, deliveryDate: this.deliveryDate })
        this.shown = false
      })
    },
    show (email = this.currentUser?.email, message = null, deliveryDate = now) {
      this.emailInput = email
      this.messageInput = message
      this.deliveryDate = deliveryDate

      this.shown = true
    },
    reset () {
      this.emailInput = null
      this.messageInput = null
      this.deliveryDate = now
    },
    cancel () {
      this.$emit('cancel')
      this.shown = false
    }
  }
}
</script>
